import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = 'tracked_impressions'

function loadTracked() {
  try {
    return new Set(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'))
  } catch { return new Set() }
}

function saveTracked(set) {
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...set])) } catch {}
}

const trackedSlugs = loadTracked()

function markTracked(slug) {
  trackedSlugs.add(slug)
  saveTracked(trackedSlugs)
}

export default class extends Controller {
  static values = { slug: String, source: { type: String, default: "search_results" } }

  connect() {
    if (this.sourceValue === "company_page") {
      // Fire immediately — but only if not already counted via search results
      if (!trackedSlugs.has(this.slugValue)) {
        markTracked(this.slugValue)
        this.trackImpression()
      }
    } else {
      // For search result cards, wait until the card is actually visible
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        threshold: 0.5
      })
      this.observer.observe(this.element)
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !trackedSlugs.has(this.slugValue)) {
        markTracked(this.slugValue)
        this.observer.disconnect()
        this.trackImpression()
      }
    })
  }

  trackImpression() {
    fetch("/api/track_impression", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slug: this.slugValue, source: this.sourceValue }),
      keepalive: true
    }).catch(() => {})
  }
}
